module.exports = "<div class=\"fab\">\n    <button pTooltip=\"Voltar\" (click)=\"backPage()\" tooltipPosition=\"top\" class=\"main\">\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/shared/layout/botao-flutuante-voltar-cards/botao-flutuante-voltar-cards.component.html
// module id = ../../../../../src/app/area-restrita/shared/layout/botao-flutuante-voltar-cards/botao-flutuante-voltar-cards.component.html
// module chunks = main